export default "__VITE_ASSET__d26647b3__"